import { render, staticRenderFns } from "./DepartmentTree.vue?vue&type=template&id=5977c091&"
import script from "./DepartmentTree.vue?vue&type=script&lang=js&"
export * from "./DepartmentTree.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports